import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { initDataProp } from '../../utility/service/api-service';
import { checkDpSuccess } from '../../utility/service/tool-service';
import SafeMarkdownRenderer from '../../components/SafeMarkdownRenderer';
import { SystemLoading,checkLoading } from '../../store/loadingStore';
const OperationGuide = () => {
    const { t } = useTranslation();
    const [guideContent, setGuideContent] = useState('');
    const [, loading] = useContext(SystemLoading);

    const axios_fetchGuideContent = () => {
        checkLoading(loading);

        initDataProp({ reqType: "operationGuideContent" })
            .then(response => {
                if (checkDpSuccess(response)) {
                    const content = response?.data?.RespBody?.operationGuideContent;
                    if (content) {
                        setGuideContent(content);
                    }
                }
            })
            .catch(error => {
                console.error('Failed to fetch operation guide:', error);
            })
            .finally(() => {
                checkLoading(loading, false);
            });
    };


    useEffect(() => {
        axios_fetchGuideContent();
    }, []);

    return (
        <div className="p-card">
            {guideContent && (
                <div className="p-card-body">
                    <SafeMarkdownRenderer content={guideContent} />
                </div>
            )}
        </div>
    );
};

export default OperationGuide;